import React, { useState, useRef, useEffect } from "react";
import marked from "marked";
// eslint-disable-next-line no-unused-vars
import Trix from "trix";

export default function TrixEditor({
  submit,
  defaultValue,
  handleChange,
  handleFocus,
  handleBlur,
  handleInitialize,
  handleFileAccepted,
  handleAttachmentAdd,
  handleAttachmentRemove,
  handleSelectionChange,
  handleBeforeInitialize,
}) {
  const trixInput = useRef(null);
  const [hide, setHide] = useState(false);

  useEffect(() => {
    if (trixInput && trixInput.current) {
      if (defaultValue !== trixInput.current.value) {
        trixInput.current.value = defaultValue;
      }
    }
  }, [defaultValue]);

  useEffect(() => {
    if (trixInput && trixInput.current) {
      setHide(false);
      trixInput.current.addEventListener("trix-change", handleChange);
      if (handleFocus)
        trixInput.current.addEventListener("trix-focus", handleFocus);
      if (handleBlur)
        trixInput.current.addEventListener("trix-blur", handleBlur);
      if (submit) trixInput.current.addEventListener("trix-blur", submit);
      if (handleInitialize)
        trixInput.current.addEventListener("trix-initialize", handleInitialize);
      if (handleFileAccepted)
        trixInput.current.addEventListener(
          "trix-file-accept",
          handleFileAccepted
        );
      if (handleAttachmentAdd)
        trixInput.current.addEventListener(
          "trix-attachment-add",
          handleAttachmentAdd
        );
      if (handleAttachmentRemove)
        trixInput.current.addEventListener(
          "trix-attachment-remove",
          handleAttachmentRemove
        );
      if (handleSelectionChange)
        trixInput.current.addEventListener(
          "trix-selection-change",
          handleSelectionChange
        );
      if (handleBeforeInitialize)
        trixInput.current.addEventListener(
          "trix-before-initialize",
          handleBeforeInitialize
        );
    }

    return () => {
      setHide(true);

      if (trixInput && trixInput.current) {
        trixInput.current.removeEventListener("trix-change", handleChange);
        if (handleFocus)
          trixInput.current.removeEventListener("trix-focus", handleFocus);
        if (handleBlur)
          trixInput.current.removeEventListener("trix-blur", handleBlur);
        if (handleInitialize)
          trixInput.current.removeEventListener(
            "trix-initialize",
            handleInitialize
          );
        if (handleFileAccepted)
          trixInput.current.removeEventListener(
            "trix-file-accept",
            handleFileAccepted
          );
        if (handleAttachmentAdd)
          trixInput.current.removeEventListener(
            "trix-attachment-add",
            handleAttachmentAdd
          );
        if (handleAttachmentRemove)
          trixInput.current.removeEventListener(
            "trix-attachment-remove",
            handleAttachmentRemove
          );
        if (handleSelectionChange)
          trixInput.current.removeEventListener(
            "trix-selection-change",
            handleSelectionChange
          );
        if (handleBeforeInitialize)
          // eslint-disable-next-line react-hooks/exhaustive-deps
          trixInput.current.removeEventListener(
            "trix-before-initialize",
            handleBeforeInitialize
          );
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const convert = () => {
    const htmlValue = marked(defaultValue);
    handleChange({ target: { value: htmlValue } });
    trixInput.current.editor.recordUndoEntry("Content updated");
    trixInput.current.editor.setSelectedRange([
      0,
      trixInput.current.editor.getDocument().getLength(),
    ]);
    trixInput.current.editor.insertHTML(htmlValue);
  };

  return hide ? null : (
    <>
      <div className="edit-textarea-label-container">
        <label htmlFor="edit-textarea">Content</label>
        <button className="link-button" onClick={convert}>
          Convert from Markdown
        </button>
      </div>
      <div>
        <input autoFocus type="hidden" id="trix-input" />
        <trix-editor ref={trixInput} input="trix-input" />
      </div>
      <br />
    </>
  );
}
